export default __webpack_public_path__ + "static/media/Logo.8cb5e182.svg";